import { IGetReportContasReceberAnaliticoUseCase } from "../../../presentation/useCases/read/get_report_contas_receber_analitico_use_case";
import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import dayjs from "dayjs";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { ReportData } from "../../models/report_data";

export type GetReportContasReceberAnaliticoParams = {
  requiredMimeType: ReportMimeType | null
  centroCusto?: number[] | null;
  titulo?: string | null;
  dataReceberDe?: Date | null;
  dataReceberAte?: Date | null;
  dataRecebidoDe?: Date | null;
  dataRecebidoAte?: Date | null;
  status: number[] | null;
  tipoConta?: number[] | null;
  idUsuario?: number | null;
  subconta?: number[] | null;
  cliente?: number[] | null;
  nroContratoFinanceiro?: number | null;
  dataCriacaoDe?: Date | null;
  dataCriacaoAte?: Date | null;
  dataCompetenciaDe?: Date | null;
  dataCompetenciaAte?: Date | null;
  ordenacao?: number | null;
  colunas?: {
    nroContasPagar: boolean,
    centroCusto: boolean,
    bancoPagamento: boolean,
    notaFiscal: boolean,
    nroDocumento: boolean,
    status: boolean,
    titulo: boolean,
    dataPagar: boolean,
    dataPago: boolean,
    valorPagar: boolean,
    valorPago: boolean,
    observacao: boolean,
    subconta: boolean,
    cliente: boolean,
    nroContratoFinanceiro: boolean,
    multa: boolean,
    juros: boolean,
    bdi: boolean,
    bdi2: boolean,
    bdiTotal: boolean,
    bdiTotal2: boolean,
    dataCriacao: boolean,
    dataCompetencia: boolean
  } | null;
};


export class GetReportContasReceberAnaliticoUseCase implements IGetReportContasReceberAnaliticoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(params: GetReportContasReceberAnaliticoParams): Promise<ReportData> {

    const centroCustoStr = params.centroCusto ? params.centroCusto.join(",") : "";
    const statusStr = params.status ? params.status.join(",") : "";
    const tipoContaStr = params.tipoConta ? params.tipoConta.join(",") : "";
    const subcontaStr = params.subconta ? params.subconta.join(",") : "";
    const clienteStr = params.cliente ? params.cliente.join(",") : "";

    const response = await this.repository.getReportContasReceberAnalitico({
      ...params,
      centroCusto: centroCustoStr == "" ? null : centroCustoStr,
      status: statusStr == "" ? null : statusStr,
      tipoConta: tipoContaStr == "" ? null : tipoContaStr,
      subconta: subcontaStr == "" ? null : subcontaStr,
      cliente: clienteStr == "" ? null : clienteStr,
    })

    if (response.mimeType !== "text/html") {
      const arquivoData = response.bytes;
      const arquivoNome = `contas_receber_lista_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;

  }

} 
